interface SeahorseSuccessJson<T> {
  Success: true;
  Result: T;
  ContainerId: string | undefined;
  ContainerHtml: string | undefined;
  Reload: boolean;
  PageVersion: number | undefined;
  ExtensionTaxonomyGuid: string | undefined;
}

export interface SeahorseErrorJson {
  Success: false;
  Message: string | undefined;
  ErrorCode: string;
  ErrorType: string | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSeahorseErrorJson(response: any): response is SeahorseErrorJson {
  return 'Success' in response && !response.Success && 'ErrorCode' in response;
}

type SeahorseJson<T> = SeahorseSuccessJson<T> | SeahorseErrorJson;

export default SeahorseJson;
